import { render, staticRenderFns } from "./AttentionDetection.vue?vue&type=template&id=f09d5284&scoped=true&"
import script from "./AttentionDetection.vue?vue&type=script&lang=js&"
export * from "./AttentionDetection.vue?vue&type=script&lang=js&"
import style0 from "./AttentionDetection.vue?vue&type=style&index=0&id=f09d5284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09d5284",
  null
  
)

export default component.exports